<template>
  <div id="app">  

    <!-- header -->
    <header id="header" v-bind:class="{ 'hide-menu' : this.hideMenu }" @click="showMenu()">

      <!-- header left - logo / name -->
      <div class="header-bg"></div>
      <router-link :to="{ name: 'home' }">
        <ul class="logo" @click="updateFilterTag('')">
          <li></li>
          <li class="site-name">
            <div class="img-logo"><img src="./assets/tarot_sun.svg" alt="" width="35"></div>
            <h1 @mouseover="colorFlash()" @mouseleave="colorFlashNone()" id="site-name"><!-- <span>Mr</span> --> Parvulesco</h1>            
          </li>
        </ul>
      </router-link>

      <!-- header right - search / toggle filter / about link -->
      <form id="search">
        <ul>
          <li @click="toggleSearchFilter()" class="more">
            <div v-bind:class="['lines', { 'is-active' : this.isDisplayed }]"></div>
          </li>
          <li v-bind:class="['li-search', { 'search-is-active' : this.searchIsDisplayed }]" >            
            <input class="input-search" id="search-form" placeholder="Search" name="query" @input="debounceInput" @keydown.enter="enterSubmit" type="search" autocomplete="off" required>
          </li>
          <li @click="toggleSearch()" class="search-cta">
            <label for="search-form">
              <svg height="512px" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M448.3,424.7L335,311.3c20.8-26,33.3-59.1,33.3-95.1c0-84.1-68.1-152.2-152-152.2c-84,0-152,68.2-152,152.2  s68.1,152.2,152,152.2c36.2,0,69.4-12.7,95.5-33.8L425,448L448.3,424.7z M120.1,312.6c-25.7-25.7-39.8-59.9-39.8-96.3  s14.2-70.6,39.8-96.3S180,80,216.3,80c36.3,0,70.5,14.2,96.2,39.9s39.8,59.9,39.8,96.3s-14.2,70.6-39.8,96.3  c-25.7,25.7-59.9,39.9-96.2,39.9C180,352.5,145.8,338.3,120.1,312.6z"/></svg>
            </label>
          </li>
          
          <li class="about">
            <router-link to="/about">
              <span >?</span>
            </router-link>
          </li>
          
        </ul>
                
      </form>

      <!-- header bottom - filters -->
      <div v-bind:class="['movies-ui', { 'isShow' : this.isDisplayed }]" >
        <ul>
        
          <li @click="sortBy('date')">Date</li>
          
          <li @click="sortBy('title_tmdb')">Title</li>
        
          <li @click="updateFilterTag('Action')">
            <router-link :to="{ name: 'genre', params: { genre: 'Action' }}">Action</router-link>
          </li>
          <!-- <li @click="updateFilterTag('Adventure')"><router-link :to="{ name: 'genre', params: { genre: 'Adventure' }}">
            <span>Adventure</span>
          </router-link></li> -->
          <li @click="updateFilterTag('Horror')"><router-link :to="{ name: 'genre', params: { genre: 'Horror' }}">
            <span>Horror</span>
          </router-link></li>       
          <li @click="updateFilterTag('Mystery')"><router-link :to="{ name: 'genre', params: { genre: 'Mystery' }}">
            <span>Mystery</span>
          </router-link></li>
          <li @click="updateFilterTag('Science-Fiction')"><router-link :to="{ name: 'genre', params: { genre: 'Science-Fiction' }}">
            <span>Sci-Fi</span>
          </router-link></li>
          <li @click="updateFilterTag('Thriller')"><router-link :to="{ name: 'genre', params: { genre: 'Thriller' }}">
            <span>Thriller</span>
          </router-link></li>
          <li @click="updateFilterTag('Western')"><router-link :to="{ name: 'genre', params: { genre: 'Western' }}">
            <span>Western</span>
          </router-link></li>
          <li @click="updateFilterTag('')"><router-link :to="{ name: 'home'}">
            <span>None</span>
          </router-link></li>

        </ul>
      </div>

    </header>

    <!-- content -->
    <router-view
      keep-alive
      :sortKey="this.sortKey"
      :sortOrders="this.sortOrders"
      :filterTag="this.filterTag"
      :filterKey="this.searchQuery"
      ref="movies">
    </router-view> 

    <!-- footer -->
    <div id="footer"></div>

  </div>
</template>

<script>
import Movies from './components/Movies'
import debounce from 'debounce'


export default {
  name: 'App',
  components: {
    Movies
  },

  data: function () {

    // var genre = this.$route.params.genre;    

    return {
      //initFilterTag: -1,
      sortKey: '',
      sortOrders: {title_tmdb: 1, date: 1}, //need to be init, seems props are not updated in nested props 'Object' otherwise
      searchQuery: '',
      // filterTag: genre ? genre : '',
      isDisplayed: false,
      hideMenu: false,
      searchIsDisplayed: false,
      intervalTime: '',
      colorArray: [
        '#ff690e',
        '#ff0131',
        '#03cc32',
        '#0be5ff',
        '#8b7fb2',
        '#7b1200',
        '#5af929',
        '#2977f9'
      ],
      isMobile: false,
      noScroll: false,
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.handleScroll);
    this.isMobile = (function(a){return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|android|ipad|playbook|silk|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4));})(navigator.userAgent||navigator.vendor||window.opera);
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods :{

    //to disable instant search that lags too much
    debounceInput: debounce(function (e) {
      
      //dev
      //reinit tags filters
      this.$refs.movies.updateFilterTag(false);

      setTimeout(function(){
        this.searchQuery = e.target.value;
      }.bind(this), 400);
      

    }, 250),

    enterSubmit: function (e) {
      e.preventDefault();
      console.log("enter key");
    },
    toggleSearchFilter: function() {
      var moviesTemp = document.getElementById("movies"); // to do with a class

      // console.log("this.isDisplayed: ", this.isDisplayed);
      this.isDisplayed = !this.isDisplayed
      if(window.innerWidth < 768 && this.isDisplayed) {
        this.noScroll = !this.noScroll;
        moviesTemp.style.overflow = "hidden";
        moviesTemp.style.position = "fixed";
      } else if (window.innerWidth < 768 && !this.isDisplayed) {
        moviesTemp.style.overflow = "auto";
        moviesTemp.style.position = "initial";
      }
        
        //console.log("window.innerWidth: ", window.innerWidth);


    },

    toggleSearch: function() {
      // console.log("this.isDisplayed: ", this.isDisplayed);
      this.searchIsDisplayed = !this.searchIsDisplayed
    },

    colorFlash: function() {
      if(!this.isMobile) {
        var that        = this,
            randomTemp = Math.floor( Math.random() * 7 ),
            randomFirst= Math.floor( Math.random() * 7 );
        this.intervalTime = window.setInterval(function(){ 
          while (randomFirst === randomTemp) {
            randomTemp = Math.floor( Math.random() * 7 );
          }
          document.getElementById("site-name").style.color = that.colorArray[randomTemp];
          randomFirst = randomTemp
        }, 200);
      }
      
    },
    colorFlashNone: function() {
      if(!this.isMobile) {
        clearTimeout(this.intervalTime);
        document.getElementById("site-name").style.color = '#2c3e50';
      }
    },
    sortBy: function (key) {

      //to scroll and reinit number of displayed movies
      this.$refs.movies.updateFilterTag(false);
      
      setTimeout(function(){
        this.sortKey = key
        this.sortOrders[key] = (this.sortOrders[key] ? this.sortOrders[key] : 1) * -1;
      }.bind(this), 400);

      if(this.isMobile)
        this.toggleSearchFilter();
      // console.log("this.sortOrders: ", this.sortOrders);      
      // console.log("SORTBY this.sortOrders[key]: ", this.sortOrders[key]);
    },

    showMenu: function() {
      this.hideMenu = false;
    },



    updateFilterTag: function (key) {

      //reinit search
      this.searchQuery = '';
      document.getElementById('search-form').value = '';

      //reinit date/title filters 
      this.sortKey = '';
      this.sortOrders = {title_tmdb: 1, date: 1};

      //reinit tags filters
      this.$refs.movies.updateFilterTag(key);

      if(this.isMobile)
        this.toggleSearchFilter(); 
    },

    handleScroll: function (event) {
      if(!this.isMobile) {
        var currentScrollPosition = window.scrollY;
        if (currentScrollPosition > this.scrollPosition && window.scrollY > 35) {
          this.hideMenu = true;
        }else{
          this.hideMenu = false;
        }
        this.scrollPosition = currentScrollPosition;
      }
    }
  }

}
</script>


<style lang="scss">

body{
  margin: 0;
  width: 100%;
  overflow: auto;
}
body.no-scroll {
  overflow: hidden !important;
  animation: 0.35s delay-overflow;
}
@keyframes delay-overflow {
  from { overflow: auto; }
}

ul, li{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 110px;
}
header {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  transition: all 0.3s ease;
  // opacity: 1;
  
  //box-shadow: 0 5px 5px -5px #333;
  //box-shadow: 0 5px 5px rgba(182, 182, 182, 0.75);  
  &.hide-menu {
    transform: translateY( -150%);    
    // opacity: 0.8;
  }
  .header-bg {
    z-index: 1000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #FFF; 
    border-bottom: 1px solid rgba(214, 209, 209, 0.59); 
  }
  .logo{
    z-index: 1001;
    position: absolute;
    top: 50%;
    transform: translateY( -50%);
    left: 60px;
    font-size: 25px;
    li {
      display: inline-block;
      vertical-align: top;
    }  
    .site-name{
      position: relative;
      display: inline-block;
      text-transform: none;
      color: inherit;
      text-decoration: none;
      color: #2c3e50;
      //font-family: 'Park Lane NF';
      //font-family: 'yorkwhiteletter';
      font-family: 'Budmo Jiggler';


      h1 {
        text-transform: none;
        //height: 10px;
        font-size: 28px;
        margin: 0;
        span {
          font-size: 0.8em;
        }
      }
      .img-logo {
        position: absolute;
        top: 59%;
        left: -40px;
        transform: translateY(-50%);
            
      }

      //font-family:  Arial Black;
     //  color: #fff;
     //  background: #2c3e50;
     //  
     //  //font-weight: bold;
     //  -webkit-transform: skew(-15deg);
     // -moz-transform: skew(-15deg);
     //   -o-transform: skew(-15deg);
     //  //font-style: italic;
     //  padding: 5px 8px;
    }
  }


  //Webkit browsers
  input[type="search"]::-webkit-search-cancel-button {
    position: absolute;
    right: 8px;
    top: 13px;
    border-radius: 0;
  }

  #search {
    z-index: 1002;
    display: inline-block;
    position: fixed;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translateY( -50%);
    width: auto;
    ul {
      height: 35px;
      font-size: 0;
      border: 1px solid #e2dede;;
      li {
        position: relative;
        display: inline-block;
        width: 35px;
        height: 35px;
        font-size: 23px;
        transition: all 0.2s ease;
        vertical-align: middle;

        &.more, &.search-cta  {
          border-right: 1px solid #e2dede;
          cursor: pointer;          
        }
        &.search-cta label{
          display: block;
          height: 100%;
          cursor: pointer;
        }
        &.li-search {
          width: 0px;
          &.search-is-active {
            width: 151px;
            .input-search {
              opacity: 1;
              width: 150px;
            }

          }
        }
        &.about {
          a {
            display: block;
            width: 100%;
            height: 100%; 
            font-size: 23px;
            text-decoration: none;
            color: black;
            span {
              position:absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
            
        }
        svg {
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 25px;
          height: 25px;
          // cursor: pointer;
        }
      }
    }
    .input-search {
      position: relative;
      display: inline-block;
      float: left;    
      height: 35px;
      width: 0;
      padding: 0;
      border: 0;
      transition: all 0.2s ease;
      background: #fff;
      text-align: center;
      color: #000;
      font-size: 11px;
      border-radius: 0;
      
      &::-webkit-input-placeholder  {
        color: #000;
      } 
      
      
    }


    .more {
      position: relative;
      display: inline-block;
      float: left;
      
      background: #fff;
      transition: all 0.2s ease;
      
      .lines {
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 16px;
        height: 2px;
        background: #000;
         transition: all 0.5s ease;
        &:before {
          content: '';
            
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
              
          width: 2px;
          height: 16px;
          background: #000;
           transition: all 0.5s ease;
        }
        &.is-active {
          transform: translate(-50%, -50%) rotate(-180deg);
          &:before {
            opacity: 0;
          }
        }
      
      }
    }        
  }
}
.button {
  background-color: red;
  width: 60px;
  height: 60px;
}


#footer {
  padding-bottom: 50px;
}



.movies-ui{
  z-index: 999;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  margin: 0;
  font-size: 11px;
  color: white;
  border-bottom: 1px solid #e2dede;
  background-color: #FFF;
  // text-transform: uppercase;
  opacity: 0;
  transition: all 0.2s ease;
  &.isShow {
    opacity: 1;
    transform: translateY(100%);
  }
  ul {
    width: 900px;
    display: block;
    margin: auto;
    font-size: 0;
  }
 
  a {
    text-decoration: none;
    color: #000 ;

  }
  li {
    width: 95px;
    display: inline-block;
    padding: 0;
    border-right: 1px solid #e2dede;
    text-align: center;
    font-size: 11px;
    cursor: pointer;
    padding: 8px 0 6px 0;
    color: #000 ;
    a{
      display: block;

      
    }
   
    &:last-child {
      border:none;
    }

  }
}
.no-touchevents {
  #search {
    ul {
      li {
        &:hover {
          background: #e2dede;
        }
      }
    }
    .input-search {
      &:hover {
        background: #e2dede;
      }
      &:focus {
        color: #000;
        background: #e2dede;
        border-radius: 0;
      }

    }
  }
  .movies-ui {
    li {
      &:hover {
        background: #e2dede;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .movies-ui {
    height: 100vh;
    ul {

      position:absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
          
      width: 100%;
    }
    li {
      display: block;
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px solid #e2dede;
      border-right: none;
    }
  }
}
@media screen and (max-width: 640px) {
  .movies-ui {
    height: 100vh;
    ul {

      position: initial;
      transform: translate(0, 0);
          
      width: 100%;
    }
    li {
      display: block;
      width: 100%;
      padding: 10px 0;

      border-bottom: 1px solid #e2dede;
      border-right: none;
    }
  }
  header {
    #search {
      right: 21px;
    }
    .logo { 
      left:  42px;
      font-size: initial;
      .site-name {

        h1 {
          font-size: 19px;
        }
        .img-logo {
          left: -30px;
          top: 60%;
          img {
            width: 23px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?6e73ef74